module.exports = __webpack_public_path__ + "static/media/5f7cc5a969ebf3532d4c2c89_banner_800x600.45ed90ba.png";